<template>
    <div class="main">
        <download-Popup></download-Popup>
        <p class="operamini-tips" v-if="isOperamini">In order to give you a better experience, please download our
            professional APP.</p>
        <downloadheader v-show="downLoadHeaderShow" id="headwrap"></downloadheader>
        <navVue :subtitleData="getHomeSubTabList" :navSelected="currentNavTag"></navVue>
        <div class="contentWrap" id="contentWrap">
            <!-- 没有数据 -->
            <nodata v-if="getNoDataMode" :whiteMode="true"></nodata>
            <!-- loading -->
            <loading v-if="getLoadingShow"></loading>
            <carousel v-if="subtitChoose=='Headline'?true:false" :carouselImgData="getCarouselData" :firstTit="firstTit"
                      :subtit="subtitChoose"></carousel>

            <transfer-entrance v-if="subtitChoose=='Headline' && !isExternalAccess"></transfer-entrance>

            <div class="listwrap" v-if="!getNoDataMode && !getLoadingShow">
                <div class="list" v-for="(data,index) in getCurrentListData" :key="index">
                    <router-link
                        :to="{path: `/news/${getUrlTitle(subtitChoose)}/${getUrlTitle(data.title)}/${data.id}`}">
                        <list-item :listData="data" :firstTit="firstTit" :subtit="subtitChoose"></list-item>
                    </router-link>
                    <!-- <router-link
                        :to="{path: '/news?id=' + data.id + '&firstTitle='+firstTit+'&subtitle='+subtitChoose}">
                        <list-item :listData="data" :firstTit="firstTit" :subtit="subtitChoose"></list-item>
                    </router-link> -->
                </div>
                <p class="operamini-tips" v-if="isOperamini">In order to give you a better experience, please use the
                    normal mode to visit our website.</p>
                <loading v-if="!!getLoadNext"></loading>
                <div class="noMoreDatas" v-if="!getLoadNext">
                    No More Data
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    // import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import downloadheader from '@/components/downloadHeader.vue';
    import navVue from '@/components/navNew.vue';
    import carousel from '@/components/carousel.vue';
    import transferEntrance from '@/components/transferEntrance.vue';
    import listItem from '@/components/listItem.vue';
    import loading from '@/components/loading.vue';
    import nodata from '@/components/nodata.vue';
    import downloadPopup from '@/components/downloadPopup.vue';
    import axios from 'axios';
    // if (process.browser) {
    //   const VueScroller = require('vue-scroller')
    //   Vue.use(VueScroller)
    // }
    export default {
        name: 'home',
        data () {
            return {
                initUrl: '/m/app/global/2/m_new.json?plat=m',
                // initUrl:'https://m-api.allfootballapp.com/m/app/global/2/m.json?plat=m',
                // initUrl:'m/app/tabs/1.json?plat=m',
                currentNavTag: 'NEWS',
                downLoadHeaderShow: true,
                // subtitChoose: '',
                subtitData: [],
                // loading: false,
                scrollLeft: 0, // 记录滚动条长度
                leftToScreen: 0, // 点击元素距离屏幕左侧距离
                rightToScreen: 0, // 点击元素距离屏幕右侧距离
                _start: 0,
                _end: 0,
                firstTit: 'News',
                subtitle: '',
                transformY: '',
                scroll: 0,
                onScroll: function () {},
                inTime: null,
                beforeLeaveToNew: null,
                isOperamini: false,
                isExternalAccess: false
            };
        },

        computed: {
            ...mapGetters([
                'getHomeSubTabList',
                'getLoading',
                'getCarouselData',
                'getNoDataMode',
                'getLoadingShow',
                'getCurrentListData',
                'getLoadPrev',
                'getLoadNext'
            ]),
            subtitChoose () {
                return this.$store.state.navStore.subtitChoose;
            }
        },
        asyncData ({ store, route: {params: { subtitle }} }) {
            // 此函数会在组件实例化之前执行，故直接将store,route传入；
            // return store.dispatch('menusListApi');
            // // 多个时的写法
            // return Promise.all([
            //     store.dispatch('menusListApi'),
            //     store.dispatch("FETCH_COMMENTS",id)
            // ])
            let allFetch = async () => {
                let menus = await store.dispatch('menusListApi', {subtitle, type: 'NEWS'});
                const chooseArr = store.getters.getHomeSubTabList.filter(ele => {
                    return ele.label === store.state.navStore.subtitChoose;
                });
                let newsList = await store.dispatch('newsListApi', ...chooseArr);
                return Promise.all([
                    menus,
                    newsList
                ]);
            };
            return allFetch();
        },
        head () {
            const referer = this.subtitChoose === 'Headline' ? 'Football' : 'Football' + this.subtitChoose;
            const HOST = process.env.NODE_ENV === 'production' ? 'https://m.allfootballapp.com' : 'https://test-m.allfootballapp.com';

            return {
                title: `${referer} News | All Football`,
                link: [{
                    rel: 'amphtml',
                    href: HOST + '/amp' + this.$route.fullPath
                }],
                meta: [
                    {
                        name: 'description',
                        content: `The best football community for football fans only, providing the ${referer} news, transfer rumours, commentary, match reports`
                    },
                    {
                        name: 'keywords',
                        content: `${referer}, ${referer} news, transfer rumours, commentary, match reports`
                    }
                ]
            };
        },

    updated() {
        if (process.browser) {
            // 仅在客户端环境下执行
            this.isExternalAccess = window.location.hostname.indexOf('quanshizuqiu') > -1
        }
    },

        mounted () {
           this.isExternalAccess = window.location.hostname.indexOf('quanshizuqiu') > -1;

            let that = this;
            let screenHeight = window.screen.height;
            let body = document.body;
            this.onScroll = function () {
                that.stickyFn();
                // if(that.loading) return;
                if (that.getLoading || !document.getElementById('headwrap')) return;
                let scrollTop = document.body.scrollTop;
                let footerOffsetTop = body.getBoundingClientRect().bottom;
                let headwrap = document.getElementById('headwrap');
                let contentWrap = document.getElementById('contentWrap');
                // let headHeight=headwrap.offsetHeight;
                if (footerOffsetTop - screenHeight < 6) {
                    console.log('刷新～～～');
                    that.loadingFn();
                }
            };
            window.addEventListener('scroll', this.onScroll, false);
            let utilObj = require('@/util/util.js');
            utilObj.timeForInOut();
            this.isOperamini = utilObj.checkOperamini();
        },
        methods: {
            initSubtitle: function () {
                axios.get(global.apiDomain + this.initUrl).then((res) => {
                    // 获取二级导航以及默认页面数据
                    let alldata = res.data.menus.news;
                    // 获取news下的子标题文案以及对应的数据url，如headline下的数据url
                    alldata.forEach((e, index) => {
                        let dataSubtit = { 'label': e.label, 'urlApi': e.api };
                        this.subtitData.push(dataSubtit);
                    });
                });
            },
            stickyFn: function (ev) {
                window.browers = {};
                var ua = navigator.userAgent.toLowerCase();
                browers.Android = ua.match(/android/);
                browers.iOS = ua.match(/ipad|iphone|ios/);
                if (browers.Android) {
                    let topFixedWrap = document.getElementById('topFixedWrap');
                    if (!topFixedWrap) {
                        return;
                    }
                    let topFixedWrapHeight = topFixedWrap.offsetHeight;// 被定住的位置的高度
                    this.scroll = document.body.scrollTop;
                    let headwrap = document.getElementById('headwrap');
                    let headHeight = headwrap.offsetHeight;// 下载条的高度
                    let contentWrap = document.getElementById('contentWrap');// 每个二级导航下的列表内容
                    if (this.scroll >= headHeight) {
                        topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                        contentWrap.style.paddingTop = topFixedWrapHeight + 'px';
                    } else {
                        topFixedWrap.className = 'topFixedWrap';
                        contentWrap.style.paddingTop = 0 + 'px';
                    }
                }
            },
            loadingError: function () {
                let loadingWord = document.getElementById('loadingWord');
                loadingWord.innerHTML = 'ERROR';
            },
            loadingFn: function () {
                let that = this;
                if (!this.getLoadNext) {
                    return;
                }
                this.$store.commit('setLoading', true);
                axios.get(global.apiDomain + this.getLoadNext).then((res) => {
                    if (res.data.articles) {
                        for (let i = 0; i < res.data.articles.length; i++) {
                            this.getCurrentListData.push(res.data.articles[i]);
                        }
                        if (!!res.data.next) {
                            this.$store.commit('setLoadNext', res.data.next.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, ''));
                            this.$store.commit('setLoading', false);
                        } else {
                            this.$store.commit('setLoading', false);
                        }
                    }
                }, res => {
                    this.loadingError();
                    // error callback
                });
            },
            updateTitle: function () {
                if (this.subtitChoose === 'Headline') {
                    document.title = 'All Football - Live Scores, News, Videos & Highlights';
                } else {
                    document.title = 'All Football - ' + this.subtitChoose + ' Live Scores, News, Videos & Highlights';
                }
            }
        },
        watch: {
            // getLoadNext:function(){
            //   console.log(this.getLoadNext)
            // }
        },
        beforeRouteEnter: (to, from, next) => {
            this.inTime = new Date();
            if (from.meta.scrollToTop && from.path === '/news') {
                console.log(from.meta.title);
                document.title = from.meta.title;
            }
            next();
        },
        beforeRouteLeave: (to, from, next) => {
            // let that=this;
            // if(to.path =='/news'){
            //     console.log(from)
            //     to.meta.savedPosition = {
            //       x:0,
            //       y:window.scrollY
            //     }
            //     to.meta.title = document.title;
            //     that.beforeLeaveToNew = new Date();
            //     let durationToDetail = (that.beforeLeaveToNew.getTime() - that.inTime.getTime()) / 1000;
            //     sa.track('index_leave', {
            //       pageUrl: location.href,
            //       pageStayTime: durationToDetail,
            //       pagePosition: (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
            //     });
            //   }
            next();
        },
        beforeDestroy: function () {
            window.removeEventListener('scroll', this.onScroll, false);
        },
        components: {
            downloadheader, listItem, carousel, transferEntrance, navVue, loading, nodata, downloadPopup
        }
    };
</script>
<style lang="less" scoped>
    html {
        min-height: 100%;
    }

    .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .clearfix {
        *zoom: 1;
    }

    .clear {
        clear: both;
    }

    html::-webkit-scrollbar {
        display: none;
    }

    body::-webkit-scrollbar {
        display: none;
    }

    .main::-webkit-scrollbar {
        display: none;
    }

    .list a {
        color: #2d2f32;
        display: block;
    }

    .list a {
        &:visited {
            color: #888;
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
        opacity: 0
    }

    .noMoreDatas {
        font-size: 1rem;
        text-align: center;
        line-height: 1rem;
        padding: 1rem 0;
        color: #b5bcc4;
        display: block;
    }

    .contentWrap {
        min-height: 65rem;
    }

    .operamini-tips {
        background: #FFFF00;
        text-align: center;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// AppHome.vue?3ed6f8d8